import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
    return (
    <footer className="footer">
        <div className="copyright2020"> © <span id="copy-year">2021</span> Meritech Software Private Limited. All right reserved. </div>
    </footer>
    );
}

export default Footer;